import { Fragment } from 'react';
import {
  EntityKindPicker,
  EntityLifecyclePicker,
  EntityNamespacePicker,
  EntityOwnerPicker,
  EntityProcessingStatusPicker,
  EntityTagPicker,
} from '@backstage/plugin-catalog-react';
import { InfraTypeCatalogFilter } from './InfraTypeCatalogFilter';
import { INFRA_TYPE_IMAGE_BUILD } from './catalogInfraTypes';

/** Images menu: shared gcp-image-build inventory (no created-by scope picker). */
export const ImagesCatalogFilters = () => (
  <Fragment>
    <InfraTypeCatalogFilter includeTypes={[INFRA_TYPE_IMAGE_BUILD]} />
    <EntityKindPicker initialFilter="component" />
    <EntityOwnerPicker />
    <EntityLifecyclePicker />
    <EntityTagPicker />
    <EntityProcessingStatusPicker />
    <EntityNamespacePicker />
  </Fragment>
);
